import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import Joi from 'joi-browser';
import { Box } from '@mui/material';
import parts from '../../../utilities/parts';

import WorkerInfoApi from '../../../services/workers/workerInfo/WorkerInfoApi';
import WorkerInfoService from '../../../services/workers/workerInfo/WorkerInfoService';
import { WorkerHeader } from '../header/WorkerHeader';
import { WorkerInfoForm } from '../form/WorkerInfoForm';
import { CcusWorkerInfoForm } from '../form/CcusWorkerInfoForm';
import Information from '../../modals/common/Information';
import Confirmation from '../../modals/common/Confirmation';
import CommonModal from '../../modals/common/Modal';
import { CcusConnectingDialog } from '../../modals/CcusConnectingDialog';
import masterSlideLoader from '../../../utilities/masterSlideLoader';
import { messageUtility } from '../../../utilities/messageUtility';
import { validationByJoi } from '../../../utilities/commonValidation';
import {
  extractErrorMessage,
  getZendeskArticleUrl,
} from '../../../utilities/commonUtil';
import {
  isNullOrUndefinedOrEmptyStr,
  replaceTagInErrorMessage,
} from '../../../utilities/stringUtil';
import { isTargetRoleId } from '../../../utilities/roleUtility';
import { setWaitTime } from '../../../utilities/commonUtil';
import {
  WORKER_TAB,
  DATE_TIME_FORMAT,
  WORKER_PAGE_STATUS,
  TIME_OUT_TWO_SECOND,
  STATUS_CODE,
  DIALOG_STATUS,
  SEX_TYPE,
  USER_ROLES,
  CCUS_WORKER_DATA_FETCH_FLG,
  CCUS_SYNCED_STATUS,
  ZENDESK_URL_GUIDE,
  LEVEL_WORKER,
  RANK_CONSISTENCY_STATUS,
  TAB_KEY_STATUS,
  ZENDESK_LINK_IDS,
  ENV_VARS,
  FAQ_URL,
} from '../../../utilities/constants';
import Style from '../../../styles/componentStyle/worker/workerInfo/worker-info.scss';
import WarningIcon from '../../../images/icon/icon--warning.svg';
import ConnectCCUSErrorImage from '../../../images/connect_ccus_error.svg';
import {
  FormElement,
  FormElementContainer,
  FormElementContainerItem,
  FormElementContainerItemLabel,
  FormList,
  FormListItem,
  FormListSubHeader,
} from '../../CommonFormComponents';
import { convertDate } from '../../../utilities/validateDateUtil';
import UsersApi from '../../../services/users/UsersApi';
import LocalStorageService from '../../../services/utilities/LocalStorageService';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import { HEAD_OFFICE_OPTION } from '../../PartnerCompanyBranchDropdown';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import { CcusLineComponent, CcusTitleBlock } from '../../CcusFormComponent';
import {
  getColorRankConsistencyStatusName,
  getLevelWorkerName,
  getMessageRankConsistencyStatus,
  getRankConsistencyStatusName,
} from '../../../utilities/workerUtil';
import { FetchCcusDescription } from '../../FetchCcusDescription';
import EventMg, { EventType } from '../../../utilities/EventManager';
import { Description } from '../../Description';
import { isCcusJigyousyaNotConnectedError } from '../../../utilities/apiErrorMessage';

/**
 * 作業員基本情報ページ
 * @props {object}pageStatus:ページ情報 (新規・詳細・編集)
 * @props {string}workerId:作業員ID
 * @props {string}companyId:会社ID
 * @props {boolean}isAgencyRegister: 代行登録しているかどうか？
 * @props {function}callFetchCcusWorkersData:CCUS情報取得処理
 */
export class WorkerInfo extends React.Component {
  state = {
    isAlreadyCcusConnect: false, // 詳細・編集時にCCUS連携済みかどうか
    header: {
      // 作業員基本情報ヘッダー用プロパティ
      LinkButtonObject: {}, // 作業員一覧ページに戻るリンク (内容はbuttonObject)
      buttonObject: {}, // ボタン内容 (内容はbuttonObject)
    },
    headerButtonObject: {
      // ヘッダーで必要なモデル (詳細はWorkerHeader.jsxを参照)
      label: data.defaultButton.label, // テキスト
      className: data.defaultButton.className, // クラス名
      onClick: null, // 処理
    },
    workerInfo: {
      // 作業員基本情報データ用プロパティ (APIと連携する時に必要なプロパティ)
      id: null, // 作業員ID (APIから返ってくる作業員IDを格納する)
      company_id: null, // 会社ID
      name_sei: null, // 作業員(姓)
      name_mei: null, // 作業員(名)
      fullname: null, // 作業員(姓名)
      name_sei_kana: null, // 作業員(姓)カナ
      name_mei_kana: null, // 作業員(名)カナ
      fullname_kana: null, // 作業員(姓名)カナ
      sex: SEX_TYPE.Man.Code, // 性別 (初期値は男性とする)
      birthday: null, // 誕生日
      ccus_engineer_id: null, // CCUSID
      security_code: '', // セキュリティコード (空文字でないとWorkerInfoForm.jsxの方でConsole Errorが表示される)
      ccus_error_code: null, // CCUS連携時にエラーがあった場合のCCUSから返されたエラーコード
      ccus_error_message: null, // CCUS連携時にエラーがあった場合のCCUSから返されたエラーメッセージ
      ccus_synced_status: CCUS_SYNCED_STATUS.UNSET, // CCUS連携ステータス
      partner_company_branch: null,
      rank_consistency_status: null,
      rank_name_code: '',
      rank_consistency_checked_at: null,
      ccus_jigyousya_deleted_flag: null,
      card_info_expiration_date: null, // CCUS技能者IDの有効期限日
      ccus_seceded_flag: false, // CCUS退会フラグ
    },
    validErrorMessage: {}, // バリデーションエラーメッセージ
    cardInfoExpirationDateMessage: {}, // CCUS技能者ID有効期限日エラーメッセージ
    fetchCcusObject: {
      // CCUS技能者情報取得確認用プロパティ (APIと連携する時に必要なプロパティ)
      ccusStateManagementsId: null, // CCUS連携管理ID
      ccusEngineerId: null, // CCUSID
      companyId: null, // 会社ID
      workerId: null, // 作業員ID
      ccusWorkerDataFetchFlg: CCUS_WORKER_DATA_FETCH_FLG.OFF.ID, // CCUSマスター情報取得フラグ（作業員更新、登録時は取得しないため0固定）
    },
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    workersCcusConnectConfirmDialog: {
      // 初回CCUS連携ダイアログ用プロパティ
      approvedFlag: false, // 同意するにチェックされているか
    },
    informationModal: {
      // インフォメーションモーダル用プロパティ (ボタン1つ)
      title: null, // モーダルダイアログのタイトル
      message: null, // モーダルダイアログのメッセージ
      buttonText: null, // モーダルダイアログのボタンのタイトル
    },
    ccusConnectErrorMessage: null, // CCUSとの連携に失敗した時のエラーメッセージ
    isManagerPermission: false,
    lastConnectedAt: '',
    roanToChoseiFlg: false, // 労安からの遷移先が直接「作業員詳細」か、黒メニュー「作業員一覧」経由かを区別するフラグ
    currentCcusWorkerInfo: { // CCUS情報編集画面で現在のCCUS情報を表示する
      ccus_engineer_id: null,
      security_code: '',
      card_info_expiration_date: null,
    }
  };

  events = {};

  constructor(props) {
    super(props);

    this.updatingFlag = true; // 多重更新防止Flag
    this.updatingCcusFlag = false; // 多重更新防止Flag
    this.userId = LocalStorageService.getUserId();
    this.selectedCompanyId = SessionStorageService.getSessionSelectedPartnerCompanyId();
    this.ccusConnectErrorFlag = false; //CCUS連携に失敗ダイアログ表示Flag

    if (
      ![
        WORKER_PAGE_STATUS.NEW,
        WORKER_PAGE_STATUS.EDIT,
        WORKER_PAGE_STATUS.CONFIRM,
      ].includes(props.pageStatus)
    ) {
      throw new Error('WorkerInfo.jsx constructor props.pageStatus');
    }
    if (_.isUndefined(props.companyId)) {
      throw new Error('WorkerInfo.jsx constructor props.companyId');
    }

    // 登録情報のstateに会社IDをセットする
    this.state.workerInfo.company_id = props.companyId;

    // WorkerInfoForm.jsxに渡すイベント
    this.events = {
      setValue: this.setValue,
      validate: this.validate,
      setCalendar: this.setCalendar,
      setCardInfoExpirationDate: this.setCardInfoExpirationDate,
      transcriptCcusWorkerValue: this.transcriptCcusWorkerValue,
    };

    this.state.roanToChoseiFlg = props.roanToChoseiFlg;
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createNewPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createConfirmPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createEditPageHeaderButton(this.state);
        break;
      default:
        break;
    }
  }

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    const state = _.cloneDeep(this.state);

    if (!_.isUndefined(this.props.workerId)) {
      await WorkerInfoApi.fetchWorkerInfo(
        this.props.companyId,
        this.props.workerId
      ).then(response => {
        if (response.result) {
          state.workerInfo = Object.assign(
            state.workerInfo,
            response.data.entities
          );

          state.isAlreadyCcusConnect = !!(
            this.props.pageStatus.EDIT_MODE && state.workerInfo.ccus_engineer_id
          );
          state.workerInfo.rank_name_code &&
            (state.workerInfo.rank_name_code = Number(
              state.workerInfo.rank_name_code
            ));

          if (!isNullOrUndefinedOrEmptyStr(state.workerInfo.birthday)) {
            state.workerInfo.birthday = moment(
              new Date(state.workerInfo.birthday).toISOString()
            ).format(DATE_TIME_FORMAT.slashDateFormat);
          }

          if (!isNullOrUndefinedOrEmptyStr(state.workerInfo.card_info_expiration_date)) {
            state.workerInfo.card_info_expiration_date = moment(
              new Date(state.workerInfo.card_info_expiration_date).toISOString()
            ).format(DATE_TIME_FORMAT.slashDateFormat);
          }

          state.currentCcusWorkerInfo.ccus_engineer_id = state.workerInfo.ccus_engineer_id;
          state.currentCcusWorkerInfo.security_code = state.workerInfo.security_code;
          state.currentCcusWorkerInfo.card_info_expiration_date = state.workerInfo.card_info_expiration_date;
        }
      });
    }

    this.setState(state, () => {
      this.updatingFlag = false; // 画面ロード後更新可能になる
    });
    this.settingPermission();
  }

  settingPermission = () => {
    UsersApi.fetchCompanyUserPermissions(this.selectedCompanyId, {
      buildee_manager_flg: 1,
    }).then(({ result, data }) => {
      let isManagerPermission = false;

      if (result && data.total > 0) {
        const { company_user_permissions: permissions } = data.entities;
        for (let permission of permissions) {
          if (permission.user_id === Number(this.userId)) {
            isManagerPermission = true;
            break;
          }
        }
      }

      this.setState({ isManagerPermission });
    });
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - START
   * =====================================================
   */

  /**
   * buttonObjectを初期化する
   * @param {object} state: ステート
   * */
  clearButtonObject = state => {
    state.headerButtonObject.label = data.defaultButton.label;
    state.headerButtonObject.className = data.defaultButton.className;
    state.headerButtonObject.onClick = null;
    return state;
  };

  /**
   * 作業員一覧ページに戻るためのリンクを作成する
   * @param {object} state: ステート
   * */
  createObjectForMoveToWorkerList = state => {
    state.headerButtonObject.label = data.buttonLink.label;
    state.headerButtonObject.className = data.buttonLink.defaultClassName;
    state.headerButtonObject.onClick = this.handlerMoveToWorkerList.bind(this);
    state.header.LinkButtonObject.moveToWorkerList = _.cloneDeep(
      state.headerButtonObject
    );
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 新規作成画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createNewPageHeaderButton = state => {
    // やめるボタン作成
    state.headerButtonObject.label = data.header.new.button.cancel.label;
    state.headerButtonObject.className =
      data.header.new.button.cancel.className;
    state.headerButtonObject.onClick = this.handlerMoveToBackPage;
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 登録ボタン作成
    state.headerButtonObject.label = data.header.new.button.register.label;
    state.headerButtonObject.className =
      data.header.new.button.register.className;
    state.headerButtonObject.onClick = this.handlerRegisterOrUpdateWorkerInfo;
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 詳細画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createConfirmPageHeaderButton = state => {
    if (isTargetRoleId([USER_ROLES.partner])) {
      // 編集ボタン作成
      state.headerButtonObject.label = data.header.confirm.button.edit.label;
      state.headerButtonObject.className =
        data.header.confirm.button.edit.className;
      state.headerButtonObject.onClick = () => {
        this.moveToWorkerEdit();
      };
      state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    }
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 編集画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createEditPageHeaderButton = state => {
    // 編集をやめるボタン作成
    state.headerButtonObject.label = data.header.edit.button.cancel.label;
    state.headerButtonObject.className =
      data.header.edit.button.cancel.className;
    state.headerButtonObject.onClick = this.handlerMoveToBackPage;
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 更新ボタン作成
    state.headerButtonObject.label = data.header.edit.button.update.label;
    state.headerButtonObject.className =
      data.header.edit.button.update.className;
    state.headerButtonObject.onClick = this.handlerRegisterOrUpdateWorkerInfo;
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 登録・編集をやめる時にダイアログの文言を設定する
   * */
  handlerMoveToBackPage = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showCancelEditDialog();
        break;
      default:
        break;
    }
  };

  /**
   * 作業員一覧へ戻るリンクをクリックした時の処理
   * */
  handlerMoveToWorkerList = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveToWorkerList();
        break;
      default:
        break;
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 前のページに戻る
   */
  backToPage = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
        this.moveToWorkerList();
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.moveToWorkerConfirm();
        break;
      default:
        break;
    }
  };

  /**
   * 作業員一覧画面に遷移する
   */
  moveToWorkerList = () => {
    masterSlideLoader.show('Workers', { state: {} });
  };

  /**
   * 作業員詳細画面に遷移する
   */
  moveToWorkerConfirm = (workerId = this.props.workerId) => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerConfirm', {
      state: {
        id: `${WORKER_TAB.WORKER_INFO.TAB_NAME},${workerId}`,
      },
    });
  };

  /**
   * 作業員編集画面に遷移する
   */
  moveToWorkerEdit = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerEdit', {
      state: {
        id: `${WORKER_TAB.WORKER_INFO.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * ダイアログを閉じる
   * informationModalの文言を初期化する
   * */
  closeDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.disabled.id,
      informationModal: {
        ...this.state.informationModal,
        title: null,
        message: null,
        buttonText: null,
      },
      ccusConnectErrorMessage: null,
    });
  };

  closeDialogNotMatchingRankNameCode = (setNotMatchingStatus = false) => {
    this.closeDialog();
    if (setNotMatchingStatus) {
      this.setState({
        workerInfo: {
          ...this.state.workerInfo,
          rank_consistency_status: RANK_CONSISTENCY_STATUS.NOT_MATCHING.value,
          rank_consistency_checked_at: this.state.lastConnectedAt,
        },
      });
    }
  };

  /**
   * 基本情報の登録・更新時に表示されるダイアログを閉じる
   * informationModalの文言を初期化する
   * 作業員詳細画面に遷移する
   * */
  closeRegisterAndUpdateDialog = () => {
    this.setState(
      {
        dialogStatus: DIALOG_STATUS.disabled.id,
        informationModal: {
          ...this.state.informationModal,
          title: null,
          message: null,
          buttonText: null,
        },
        ccusConnectErrorMessage: null,
      },
      () => {
        this.moveToWorkerConfirm(this.state.workerInfo.id);
      }
    );
  };

  /**
   * 初回CCUS連携ダイアログを閉じる
   * */
  closeWorkersCcusConnectConfirmDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.disabled.id,
      workersCcusConnectConfirmDialog: {
        ...this.state.workersCcusConnectConfirmDialog,
        approvedFlag: false,
      },
    });
  };

  /**
   * CCUS連携を同意するチェックを変更
   * */
  changeCcusApprovedFlag = () => {
    const { workersCcusConnectConfirmDialog } = this.state;
    const { approvedFlag } = workersCcusConnectConfirmDialog;
    this.setState({
      workersCcusConnectConfirmDialog: {
        ...workersCcusConnectConfirmDialog,
        approvedFlag: !approvedFlag,
      },
    });
  };

  /**
   * 登録・編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    this.setState({ dialogStatus: DIALOG_STATUS.cancelEditDialogEnabled.id });
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.leaveThisPageDialogEnabled.id,
    });
  };

  /**
   * APIのエラーメッセージダイアログを表示する
   * @param {object} response レスポンスデータ
   * */
  showErrorMessageDialog = response => {
    this.setState({
      dialogStatus: DIALOG_STATUS.otherErrorDialogEnabled.id,
      informationModal: {
        ...this.state.informationModal,
        title: null,
        message: extractErrorMessage(response),
        buttonText: messageUtility.getMessage('I-000-017'),
      },
    });
  };

  /**
   * CCUS連携失敗時にCCUS連携失敗モーダルを表示する
   * @param {object} response レスポンスデータ
   * */
  showCcusConnectFailedDialog = response => {
    const isErrorDATN0204E =
      _.get(response, 'data.data.entities.ccus_error_code') === 'DATN0204E';
    this.setState({
      dialogStatus: isErrorDATN0204E
        ? DIALOG_STATUS.ccusConnectErrorDATN0204EDialogEnabled.id
        : DIALOG_STATUS.ccusConnectErrorDialogEnabled.id,
      ccusConnectErrorMessage: extractErrorMessage(response),
    });
  };

  /**
   * 作業員登録時に登録成功ダイアログを表示する
   * */
  showRegisterSuccessDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.registerDialogEnabled.id,
    });
  };

  /**
   * 作業員更新時に更新成功ダイアログを表示する
   * */
  showUpdateSuccessDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.updateSuccessDialogEnabled.id,
    });
  };

  /**
   * 作業員登録・更新時にCCUS連携成功ダイアログを表示する
   * CCUSと通信を行った場合
   * */
  showCcusConnectSuccessDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.ccusConnectSuccessDialogEnabled.id,
    });
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * API周りの処理 - START
   * =====================================================
   */

  /**
   * 登録・更新を実行する前に実行する処理
   * バリデーション・CCUS初回連携時のダイアログの表示
   */
  handlerRegisterOrUpdateWorkerInfo = () => {
    if (this.validate()) {
      const {
        workerInfo,
        isAlreadyCcusConnect,
        workersCcusConnectConfirmDialog,
      } = this.state;

      if (
        !isNullOrUndefinedOrEmptyStr(workerInfo.ccus_engineer_id) &&
        !isAlreadyCcusConnect &&
        !workersCcusConnectConfirmDialog.approvedFlag
      ) {
        this.setState({
          dialogStatus: DIALOG_STATUS.ccusConnectConfirmDialogEnabled.id,
        });
        return;
      }

      this.ccusConnectErrorFlag = false;

      switch (this.props.pageStatus.ID) {
        case WORKER_PAGE_STATUS.NEW.ID:
          this.handlerRegisterWorkerInfo();
          break;
        case WORKER_PAGE_STATUS.EDIT.ID:
          this.handlerUpdateWorkerInfo();
          break;
        default:
          break;
      }
    }
  };

  /**
   * 作業員登録前にCCUSと連携するか確認し、必要であれば連携する
   */
  handlerRegisterWorkerInfo = () => {
    // 多重更新防止
    if (this.updatingCcusFlag) {
      return;
    }
    this.updatingCcusFlag = true;

    const state = _.cloneDeep(this.state);
    state.workerInfo.birthday = convertDate(state.workerInfo.birthday);
    state.workerInfo.card_info_expiration_date = convertDate(state.workerInfo.card_info_expiration_date);
    const params = WorkerInfoService.createRegisterWorkerParam(
      state.workerInfo
    );

    if (!isNullOrUndefinedOrEmptyStr(state.workerInfo.ccus_engineer_id)) {
      state.dialogStatus = DIALOG_STATUS.ccusConnectingDialogEnabled.id;
      this.setState(state);

      WorkerInfoApi.beginFetchCcusInfo(params)
        .then(response => {
          if (
            (_.has(response.data, 'result') &&
              response.data.result === false) ||
            (_.has(response, 'result') && response.result === false)
          ) {
            this.updatingCcusFlag = false;
            const showErrorMessageDialog = _.get(
              response,
              'data.show_error_message_dialog'
            );
            if (showErrorMessageDialog) {
              this.showErrorMessageDialog(response);
            } else {
              this.ccusConnectErrorFlag = true;
              this.showCcusConnectFailedDialog(response);
            }
          } else {
            state.fetchCcusObject.ccusStateManagementsId =
              response.data.entities.ccus_state_management_id;
            state.fetchCcusObject.ccusEngineerId =
              response.data.entities.ccus_engineer_id;
            state.fetchCcusObject.companyId = this.props.companyId;
            state.fetchCcusObject.workerId = state.workerInfo.id;
            this.monitoringFetchCcusWorkersData()
              .then(async response => {
                if (
                  isNullOrUndefinedOrEmptyStr(response) === false &&
                  parts.isEmptyObject(response) === false &&
                  response.status === STATUS_CODE.ok
                ) {
                  const rankNameCode = this.state.workerInfo.rank_name_code;
                  if (rankNameCode) {
                    const params = {
                      ccus_engineer_id: this.state.workerInfo.ccus_engineer_id,
                    };
                    const response = await WorkerInfoApi.fetchRankCcus(
                      this.props.companyId,
                      params
                    );
                    const ccusRankNameCode = _.get(
                      response,
                      'data.entities.ccus_worker.rank_name_code'
                    );
                    const lastConnectedAt = _.get(
                      response,
                      'data.entities.last_connected_at'
                    );
                    if (Number(rankNameCode) !== Number(ccusRankNameCode)) {
                      this.updatingCcusFlag = false;
                      return this.setState({
                        dialogStatus:
                          DIALOG_STATUS.ccusNotMatchingRankNameCode.id,
                        lastConnectedAt,
                      });
                    }
                  }
                  this.updatingCcusFlag = false;
                  this.registerWorkerInfo(true);
                }
              })
              .catch(error => {
                this.updatingCcusFlag = false;
                this.ccusConnectErrorFlag = true;
                this.showCcusConnectFailedDialog(error);
              });
          }
        })
        .catch(error => {
          this.updatingCcusFlag = false;
          this.ccusConnectErrorFlag = true;
          this.showCcusConnectFailedDialog(error);
        });
    } else {
      this.updatingCcusFlag = false;
      this.registerWorkerInfo();
    }
  };

  /**
   * 作業員登録
   * @param {boolean} ccusSyncedFlag CCUSと連携済みかどうか？ ( true: 連携済み false: 未連携、連携不要 )
   */
  registerWorkerInfo = (ccusSyncedFlag = false) => {
    // 多重更新防止
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;

    const { companyId } = this.props;
    const { workerInfo } = this.state;
    const newWorkerInfo = {
      ...workerInfo,
      birthday: convertDate(workerInfo.birthday),
      card_info_expiration_date: convertDate(workerInfo.card_info_expiration_date),
    };
    const params = {
      ...WorkerInfoService.createRegisterWorkerParam(newWorkerInfo),
      ccus_synced_flag: ccusSyncedFlag,
    };

    const { partner_company_branch: branch } = workerInfo;
    if (branch && branch.id !== HEAD_OFFICE_OPTION.id) {
      params.partner_company_branch_id = branch.id;
    }

    WorkerInfoApi.registerWorker(companyId, params)
      .then(response => {
        const { result, data } = response;

        if (!isNullOrUndefinedOrEmptyStr(_.get(data, 'entities.birthday'))) {
          data.entities.birthday = moment(
            new Date(data.entities.birthday).toISOString()
          ).format(DATE_TIME_FORMAT.slashDateFormat);
        }

        if (!isNullOrUndefinedOrEmptyStr(_.get(data, 'entities.card_info_expiration_date'))) {
          data.entities.card_info_expiration_date = moment(
            new Date(data.entities.card_info_expiration_date).toISOString()
          ).format(DATE_TIME_FORMAT.slashDateFormat);
        }

        if (result) {
          this.setState({ workerInfo: data.entities }, () => {
            if (
              data.entities.ccus_engineer_id &&
              this.ccusConnectErrorFlag === true
            ) {
              this.showRegisterSuccessDialog();
            } else if (
              data.entities.ccus_engineer_id &&
              this.ccusConnectErrorFlag === false
            ) {
              this.showCcusConnectSuccessDialog();
            } else {
              this.showRegisterSuccessDialog();
            }
          });
          EventMg.trigger(EventType.FETCH_CONSISTENCY_STATUS);
        } else {
          const correctCardInfoExpirationDate = _.get(data, 'data.entities.correct_card_info_expiration_date');
          if (correctCardInfoExpirationDate) {
            const stateValue = _.cloneDeep(this.state);
            stateValue.correctCardInfoExpirationDate = correctCardInfoExpirationDate;
            stateValue.validErrorMessage['card_info_expiration_date'] = messageUtility.getMessage('E-000-079');
            this.setState(stateValue, () => {
              this.closeDialog();
            });
          } else {
            this.showErrorMessageDialog(response);
          }
        }
      })
      .catch(error => {
        this.showErrorMessageDialog(error);
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  /**
   * 作業員更新前にCCUSと連携するか確認し、必要であれば連携する
   */
  handlerUpdateWorkerInfo = () => {
    // 多重更新防止
    if (this.updatingCcusFlag) {
      return;
    }
    this.updatingCcusFlag = true;

    const state = _.cloneDeep(this.state);
    state.workerInfo.birthday = convertDate(state.workerInfo.birthday);
    state.workerInfo.card_info_expiration_date = convertDate(state.workerInfo.card_info_expiration_date);
    const params = WorkerInfoService.createRegisterWorkerParam(
      state.workerInfo
    );

    if (
      isNullOrUndefinedOrEmptyStr(state.workerInfo.ccus_engineer_id) === false
    ) {
      state.dialogStatus = DIALOG_STATUS.ccusConnectingDialogEnabled.id;
      this.setState(state);

      WorkerInfoApi.beginFetchCcusInfo(params)
        .then(response => {
          if (
            (_.has(response.data, 'result') &&
              response.data.result === false) ||
            (_.has(response, 'result') && response.result === false)
          ) {
            this.updatingCcusFlag = false;
            const showErrorMessageDialog = _.get(
              response,
              'data.show_error_message_dialog'
            );
            if (showErrorMessageDialog) {
              this.showErrorMessageDialog(response);
            } else {
              this.ccusConnectErrorFlag = true;
              this.showCcusConnectFailedDialog(response);
            }
          } else {
            state.fetchCcusObject.ccusStateManagementsId =
              response.data.entities.ccus_state_management_id;
            state.fetchCcusObject.ccusEngineerId =
              response.data.entities.ccus_engineer_id;
            state.fetchCcusObject.companyId = this.props.companyId;
            state.fetchCcusObject.workerId = state.workerInfo.id;
            this.monitoringFetchCcusWorkersData()
              .then(async response => {
                if (
                  isNullOrUndefinedOrEmptyStr(response) === false &&
                  parts.isEmptyObject(response) === false &&
                  response.status === STATUS_CODE.ok
                ) {
                  const rankNameCode = this.state.workerInfo.rank_name_code;
                  if (rankNameCode) {
                    const params = {
                      ccus_engineer_id: this.state.workerInfo.ccus_engineer_id,
                    };
                    const response = await WorkerInfoApi.fetchRankCcus(
                      this.props.companyId,
                      params
                    );
                    const ccusRankNameCode = _.get(
                      response,
                      'data.entities.ccus_worker.rank_name_code'
                    );
                    const lastConnectedAt = _.get(
                      response,
                      'data.entities.last_connected_at'
                    );
                    if (Number(rankNameCode) !== Number(ccusRankNameCode)) {
                      this.updatingCcusFlag = false;
                      return this.setState({
                        dialogStatus:
                          DIALOG_STATUS.ccusNotMatchingRankNameCode.id,
                        lastConnectedAt,
                      });
                    }
                  }
                  this.updatingCcusFlag = false;
                  this.updateWorkerInfo(true);
                }
              })
              .catch(error => {
                this.updatingCcusFlag = false;
                this.ccusConnectErrorFlag = true;
                this.showCcusConnectFailedDialog(error);
              });
          }
        })
        .catch(error => {
          this.updatingCcusFlag = false;
          this.ccusConnectErrorFlag = true;
          this.showCcusConnectFailedDialog(error);
        });
    } else {
      this.updatingCcusFlag = false;
      this.updateWorkerInfo();
    }
  };

  /**
   * 作業員更新
   * @param {boolean} ccusSyncedFlag CCUSと連携済みかどうか？ ( true: 連携済み false: 未連携、連携不要 )
   */
  updateWorkerInfo = (ccusSyncedFlag = false) => {
    // 多重更新防止
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;

    const { companyId, workerId } = this.props;
    const { workerInfo } = this.state;
    const newWorkerInfo = {
      ...workerInfo,
      birthday: convertDate(workerInfo.birthday),
      card_info_expiration_date: convertDate(workerInfo.card_info_expiration_date),
    };
    const params = {
      ...WorkerInfoService.createRegisterWorkerParam(newWorkerInfo),
      ccus_synced_flag: ccusSyncedFlag,
      ccus_synced_status: _.toString(this.state.workerInfo.ccus_synced_status),
    };

    if (workerInfo.partner_company_branch) {
      params.partner_company_branch_id =
        workerInfo.partner_company_branch.id === HEAD_OFFICE_OPTION.id
          ? null
          : workerInfo.partner_company_branch.id;
    }

    WorkerInfoApi.updateWorker(companyId, workerId, params)
      .then(response => {
        const { result, data } = response;

        if (result) {
          if (
            data.entities.ccus_engineer_id &&
            this.ccusConnectErrorFlag === true
          ) {
            this.showUpdateSuccessDialog();
          } else if (
            data.entities.ccus_engineer_id &&
            this.ccusConnectErrorFlag === false
          ) {
            this.showCcusConnectSuccessDialog();
          } else {
            this.showUpdateSuccessDialog();
          }
          EventMg.trigger(EventType.FETCH_CONSISTENCY_STATUS);
        } else {
          const correctCardInfoExpirationDate = _.get(data, 'data.entities.correct_card_info_expiration_date');
          if (correctCardInfoExpirationDate) {
            const stateValue = _.cloneDeep(this.state);
            stateValue.correctCardInfoExpirationDate = correctCardInfoExpirationDate;
            stateValue.validErrorMessage['card_info_expiration_date'] = messageUtility.getMessage('E-000-079');
            this.setState(stateValue, () => {
              this.closeDialog();
            });
          } else {
            this.showErrorMessageDialog(response);
          }
        }
      })
      .catch(error => {
        this.showErrorMessageDialog(error);
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  /**
   * CCUS連携を監視する
   * */
  monitoringFetchCcusWorkersData = async () => {
    const state = _.cloneDeep(this.state);
    const params = WorkerInfoService.createCcusMonitoringParam(
      state.fetchCcusObject
    );
    await setWaitTime(TIME_OUT_TWO_SECOND);
    return new Promise((resolve, reject) => {
      WorkerInfoApi.fetchCcusInfo(params).then(response => {
        if (
          (_.has(response.data, 'result') && response.data.result === false) ||
          (_.has(response, 'result') && response.result === false)
        ) {
          reject(response);
        } else {
          if (response.status === STATUS_CODE.accepted) {
            state.fetchCcusObject.ccusStateManagementsId =
              response.data.entities.ccus_state_management_id;
            state.fetchCcusObject.ccusEngineerId =
              response.data.entities.ccus_engineer_id;
            state.fetchCcusObject.companyId = this.props.companyId;
            state.fetchCcusObject.workerId = state.workerInfo.id;
            this.setState(state);

            // ステータスコードが処理中(202)の場合
            // 再度現場情報取得状況を監視する
            this.monitoringFetchCcusWorkersData()
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          } else if (response.status !== STATUS_CODE.ok) {
            reject(response);
          } else {
            resolve(response);
          }
        }
      });
    });
  };

  /**
   * =====================================================
   * API周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   *フォーム周りの処理 - START
   * =====================================================
   */

  /**
   * フォームに値を入れる
   * @param {*} event
   */
  setValue = event => {
    const { name, value } = event.target;
    let {
      rank_consistency_status,
      rank_consistency_checked_at,
    } = this.state.workerInfo;
    if (name === 'rank_name_code') {
      rank_consistency_status = RANK_CONSISTENCY_STATUS.UN_CONFIRM.value;
      rank_consistency_checked_at = null;
    }
    this.setState({
      workerInfo: {
        ...this.state.workerInfo,
        [name]: value,
        rank_consistency_status,
        rank_consistency_checked_at,
      },
    });
  };
  transcriptCcusWorkerValue = value => {
    this.setState({
      workerInfo: {
        ...this.state.workerInfo,
        rank_name_code: value,
        rank_consistency_status: RANK_CONSISTENCY_STATUS.UN_CONFIRM.value,
        rank_consistency_checked_at: null,
      },
    });
  };

  setCalendar = birthday => {
    this.setState({
      workerInfo: {
        ...this.state.workerInfo,
        birthday,
      },
    });
  };

  setCardInfoExpirationDate = card_info_expiration_date => {
    const stateValue = _.cloneDeep(this.state);
    stateValue.workerInfo['card_info_expiration_date'] = card_info_expiration_date;
    this.setState(stateValue, () => {
      this.validate('card_info_expiration_date');
    });
  };

  /**
   * バリデーション
   * @param {string} keyName
   */
  validate = keyName => {
    const stateValue = _.cloneDeep(this.state);
    let validateSchema = WorkerInfoService.createValidateSchema();
    const result = validationByJoi(
      Joi.object().keys(validateSchema),
      WorkerInfoService.createRegisterWorkerParam(stateValue.workerInfo)
    );

    // @TODO: 時間があればリファクタリングする
    if (isNullOrUndefinedOrEmptyStr(keyName) === false) {
      if (_.has(result.messages, keyName)) {
        stateValue.validErrorMessage[keyName] = result.messages[keyName];
      } else {
        stateValue.validErrorMessage[keyName] = '';
      }
    } else {
      //全体でバリデート
      if (result.status === false) {
        stateValue.validErrorMessage = Object.assign(
          stateValue.validErrorMessage,
          result.messages
        );
      }
    }

    this.setState(stateValue);
    return result.status;
  };

  /**
   * CCUSの補足説明文を取得する
   * （代行登録かどうかでメッセージが変わる）
   * @return {string} 補足説明文
   */
  findCcusDescription = () => {
    if (
      this.props.isAgencyRegister !== undefined &&
      this.props.isAgencyRegister === true
    ) {
      return messageUtility.getMessage('I-000-160');
    }

    return messageUtility.getMessage('I-000-159');
  };

  agencyCanFetchCcus = () => {
    return (
      this.props.isCcusConnectSuccess &&
      this.props.agencyInfo.in_upstream_ccus_field_trees &&
      this.props.isLinkedUser
    );
  };

  showFetchCcusDescription = () => {
    const REACT_APP_ZENDESK_URL = ENV_VARS.REACT_APP_ZENDESK_URL;
    if (this.props.pageStatus.ID !== WORKER_PAGE_STATUS.EDIT.ID) {
      return;
    }
    if (this.props.isAgencyRegister) {
      if (!_.has(this.props.agencyInfo, 'in_upstream_ccus_field_trees')) {
        return;
      }
      //  BLDE_V2-50226 CCUS事業者IDは削除された場合に転記情報は表示されない
      if (
        this.agencyCanFetchCcus() &&
        !this.state.workerInfo.ccus_jigyousya_deleted_flag
      ) {
        if (isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate)) {
          return (
            <FetchCcusDescription
              description={messageUtility.getMessage('I-000-161')}
              onClick={this.props.callFetchCcusWorkersData}
            />
          );
        } else {
          return (
            <FetchCcusDescription
              description={messageUtility.getMessage('I-000-162')}
              linkedToCcusDate={this.props.linkedToCcusDate}
              onClick={this.props.callFetchCcusWorkersData}
            />
          );
        }
      } else {
        return (
          <FetchCcusDescription
            description={
              <span>
                CCUSから情報を取得することができません。赤字の条件が満たされていません。
                <br />
                CCUSから代行先の情報を取得するには、下記の条件をすべて満たす必要があります。
                <br />
                <br />
                <ul className='fetch-ccus-description-message__text-list'>
                  {/* BLDE_V2-50226 CCUS事業者IDは削除された場合に文言は赤色になる */}
                  {/* BLDE_V2-50623 代行先会社はCCUSと連携されているかどうかによって文言の色は変更する */}
                  <li
                    className={
                      this.props.isCcusJigyousyaConnected &&
                      this.props.isCcusConnectSuccess &&
                      !this.state.workerInfo.ccus_jigyousya_deleted_flag
                        ? ''
                        : 'text--negative'
                    }
                  >
                    <span className='fetch-ccus-description-message__text'>
                      {messageUtility.getMessage('I-000-263')}
                    </span>
                  </li>
                  <li
                    className={this.props.isLinkedUser ? '' : 'text--negative'}
                  >
                    <span className='fetch-ccus-description-message__text'>
                      あなたのアカウントが代行先の連携ユーザーとして設定されている
                    </span>
                    {!this.props.isLinkedUser && (
                      <span>
                        （
                        <span
                          className='clickable-text'
                          onClick={() => {
                            masterSlideLoader.show('PrimeCcusPreview', {
                              state: { id: this.props.companyId },
                            });
                          }}
                        >
                          こちら
                        </span>
                        から設定してください）
                      </span>
                    )}
                  </li>
                  <li
                    className={
                      this.props.agencyInfo.in_upstream_ccus_field_trees
                        ? ''
                        : 'text--negative'
                    }
                  >
                    <span className='fetch-ccus-description-message__text'>
                      施工体制のCCUS連携を行っているいずれかの現場で、代行先の会社があなたの会社の下位協力会社として登録されている
                    </span>
                    {!this.props.agencyInfo.in_upstream_ccus_field_trees && (
                      <span>
                        （詳細は
                        <a
                          className='clickable-text'
                          href={`${getZendeskArticleUrl(
                            REACT_APP_ZENDESK_URL,
                            ZENDESK_LINK_IDS.CCUS_FIELD_TREES
                          )}`}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          こちら
                        </a>
                        をご確認ください。）
                      </span>
                    )}
                  </li>
                </ul>
              </span>
            }
            disabledCcusConnectionButton={true}
          />
        );
      }
    }
    // BLDE_V2-50226 CCUS事業者IDは削除された場合に転記情報は表示されない
    if (
      (this.props.isCcusConnectSuccess &&
        this.state.workerInfo.ccus_jigyousya_deleted_flag) ||
      !this.props.isCcusJigyousyaConnected
    ) {
      return null;
    }
    if (
      !this.props.isLinkedUser ||
      !this.state.currentCcusWorkerInfo.ccus_engineer_id ||
      !this.props.isCcusConnectSuccess
    ) {
      return (
        <FetchCcusDescription
          disabledCcusConnectionButton
          description={
            <div>
              <p>
                CCUSから情報を取得することができません。赤字の条件が満たされていません。
              </p>
              <p>
                CCUSから情報を取得するには、下記の条件をすべて満たす必要があります。
              </p>
              <ul className='fetch-ccus-description-message__text-list'>
                <li
                  className={!this.props.isLinkedUser ? 'text--negative' : ''}
                >
                  <span className='fetch-ccus-description-message__text'>
                    あなたのアカウントが自社の連携ユーザーとして設定されている
                  </span>
                  {!this.props.isLinkedUser && (
                    <span>
                      （
                      <span
                        className='clickable-text'
                        onClick={() => {
                          masterSlideLoader.show('PrimeCcusPreview', {
                            state: { id: this.props.companyId },
                          });
                        }}
                      >
                        こちら
                      </span>
                      から設定してください）
                    </span>
                  )}
                </li>
                <li
                  className={
                    !this.state.currentCcusWorkerInfo.ccus_engineer_id ||
                    !this.props.isCcusConnectSuccess
                      ? 'text--negative'
                      : ''
                  }
                >
                  <span className='fetch-ccus-description-message__text'>
                    作業員の基本情報タブにCCUS技能者IDが登録されておりCCUS連携に成功している
                  </span>
                </li>
              </ul>
              <br />
              <p>
                作業員のCCUS連携の手順は
                <a
                  className='clickable-text'
                  href={ZENDESK_URL_GUIDE.CCUS_WORKER_WARNING}
                  target='_blank'
                  rel='noreferrer noopener'
                >
                  こちら
                </a>
                をご確認ください。
              </p>
            </div>
          }
        />
      );
    }
    if (isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate)) {
      return (
        <FetchCcusDescription
          description={messageUtility.getMessage('I-000-161')}
          onClick={this.props.callFetchCcusWorkersData}
        />
      );
    } else {
      return (
        <FetchCcusDescription
          description={messageUtility.getMessage('I-000-162')}
          linkedToCcusDate={this.props.linkedToCcusDate}
          onClick={this.props.callFetchCcusWorkersData}
        />
      );
    }
  };

  // CCUS連携情報までスクロールする
  scrollToCcusWorkerInfo = () => {
    const target = _.find(document.querySelectorAll('.FormListSubHeader'), e => e.textContent === 'CCUS連携情報');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }

  /**
   * =====================================================
   * フォーム周りの処理 - END
   * =====================================================
   */

  // 画面表示
  render() {
    const isEditPage = _.includes(
      [WORKER_PAGE_STATUS.EDIT.ID],
      this.props.pageStatus.ID
    );
    const {
      ccus_error_code,
      ccus_error_message,
      ccus_engineer_id,
    } = this.state.workerInfo;
    const isErrorDATN0204E = ccus_error_code === 'DATN0204E';

    return (
      <React.Fragment>
        <WorkerHeader
          LinkButtonObject={this.state.header.LinkButtonObject}
          buttonObject={this.state.header.buttonObject}
          errorMessagesCount={
            Object.values(this.state.validErrorMessage).filter(v => v !== '')
              .length
          }
        />
        <div className='contruction-detail-view__bar' />

        <div className='contruction-detail-view__main contruction-detail-view__main--fixed'>
          {!isNullOrUndefinedOrEmptyStr(ccus_error_message) &&
            !isErrorDATN0204E && (
              <div className={Style.ccusConnectErrorMessage}>
                <div className='error-title'>
                  {messageUtility.getMessage('I-002-005-11')}
                </div>
                <div className='error-message'>
                  {replaceTagInErrorMessage(ccus_error_message)}
                </div>
                <br />
                <div>
                  CCUS連携エラーの詳細は
                  <a
                    className='clickable-text'
                    href={ZENDESK_URL_GUIDE.CCUS_WORKER_CONNECT}
                    target='_blank'
                    rel='noreferrer noopener'
                  >
                    こちら
                  </a>
                  をご確認ください。
                </div>
              </div>
            )}
          {isErrorDATN0204E && (
            <Description type='warning' style={{ margin: '8px 0' }}>
              <div className='ccus-worker-error-description'>
                <div className='ccus-worker-error-description__header'>
                  <img src={WarningIcon} alt='icon-warning' />
                  <Box ml='8px'>
                    {messageUtility.getMessage('I-002-005-11')}
                  </Box>
                </div>
                <span>
                  この技能者IDは、CCUS上でこの会社に関連付けされていないため連携に失敗しました。
                </span>
                <br />
                <span>
                  Buildeeで作業員をCCUS連携するためには事前にCCUSで技能者と所属事業者の関連付けが必要です。
                </span>
                <br />
                <span>
                  CCUSで関連付けを行った後に、再度この画面で作業員の基本情報を編集＞更新してください。
                </span>
                <br />
                <br/>
                <span>
                  CCUSでの関連付けの概要と確認方法については
                  <a
                    href={FAQ_URL.CCUS_ASSOCIATION}
                    target='_blank'
                    rel='noreferrer noopener'
                    className='clickable-text'
                  >
                    こちら
                  </a>
                  をご確認ください。
                </span>
                <br />
                <span>
                  CCUSでの関連付けの手順については
                  <a
                    href={FAQ_URL.CCUS_DETAIL}
                    target='_blank'
                    rel='noreferrer noopener'
                    className='clickable-text'
                  >
                    こちら
                  </a>
                  をご確認ください。
                </span>
              </div>
            </Description>
          )}
          {this.state.workerInfo.ccus_seceded_flag && this.props.pageStatus.ID === WORKER_PAGE_STATUS.CONFIRM.ID && (
            <div className={Style.ccusSecededMessage}>
              <span className='clickable-text' onClick={this.scrollToCcusWorkerInfo}>CCUS連携情報</span>の有効期限が切れています。<br/>
              更新済みの場合は編集画面から更新操作をしてください。
            </div>
          )}
          {this.showFetchCcusDescription()}
          <FormList className='form-list form-list--no-margin form-list-default'>
            {this.props.description && this.props.description}
            {(!this.props.workerId ||
              (this.props.workerId && this.state.workerInfo.id)) && (
              <WorkerInfoForm
                events={this.events}
                messages={this.state.validErrorMessage}
                formValues={this.state.workerInfo}
                disableCcusConnect={this.state.isAlreadyCcusConnect}
                disabledAll={this.props.pageStatus.DISABLED_ALL}
                pageStatus={this.props.pageStatus}
                isManagerPermission={this.state.isManagerPermission}
                dialogStatus={this.state.dialogStatus}
              />
            )}
            <CcusWorkerInfoForm
              events={this.events}
              messages={this.state.validErrorMessage}
              supplementCcusRelationDescription={this.findCcusDescription()}
              formValues={this.state.workerInfo}
              disableCcusConnect={this.state.isAlreadyCcusConnect}
              disabledAll={(() => {
                if (this.props.pageStatus.DISABLED_ALL) {
                  return true;
                }
                if (this.state.workerInfo.ccus_synced_status === CCUS_SYNCED_STATUS.DONE.ID) {
                  return true;
                }
                return false;
              })()}
              dialogStatus={this.state.dialogStatus}
              pageStatus={this.props.pageStatus}
              correctCardInfoExpirationDate={this.state.correctCardInfoExpirationDate}
              currentCcusWorkerInfo={this.state.currentCcusWorkerInfo}
            />
            <LevelWorkerForm
              pageStatus={this.props.pageStatus}
              rankNameCode={this.state.workerInfo.rank_name_code}
              rankConsistencyStatus={
                this.state.workerInfo.rank_consistency_status
              }
              ccusSyncedStatus={this.state.workerInfo.ccus_synced_status}
              rankNameCodeCCUS={this.props.ccusWorker.rank_name_code}
              rankConsistencyCheckedAt={
                this.state.workerInfo.rank_consistency_checked_at
              }
              isCcusConnectSuccess={this.props.isCcusConnectSuccess}
              dialogStatus={this.state.dialogStatus}
              event={this.events}
              // BLDE_V2-50226 CCUS事業者IDは削除されたかどうか決断
              isCcusJigyousyaDeleted={
                this.state.workerInfo.ccus_jigyousya_deleted_flag
              }
            />
          </FormList>
        </div>

        {/* エラーが発生した時のメッセージ */}
        <Information
          rootClassName={Style.refetchCompleteDialog}
          visible={
            this.state.dialogStatus === DIALOG_STATUS.otherErrorDialogEnabled.id
          }
          title={this.state.informationModal.title}
          message={this.state.informationModal.message}
          buttonText={this.state.informationModal.buttonText}
          onClose={this.closeDialog}
        />

        {/* 初回CCUS連携ダイアログ */}
        <Confirmation
          rootClassName={Style.workersCcusConnectConfirmDialog}
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.ccusConnectConfirmDialogEnabled.id
          }
          title={data.dialog.WorkersCcusConnectConfirm.title}
          message={
            <WorkersCcusConnectConfirmDialog
              approvedFlag={
                this.state.workersCcusConnectConfirmDialog.approvedFlag
              }
              onChange={() => this.changeCcusApprovedFlag()}
            />
          }
          confirmButtonText={messageUtility.getMessage('I-000-054')}
          isNegative
          disabledConfirmButton={
            this.state.workersCcusConnectConfirmDialog.approvedFlag === false
          }
          negativeButtonClassName={
            this.state.workersCcusConnectConfirmDialog.approvedFlag === true
              ? 'btn--effective'
              : 'btn-disabled'
          }
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={this.handlerRegisterOrUpdateWorkerInfo}
          onCancel={this.closeWorkersCcusConnectConfirmDialog}
        />

        {/* CCUS連携失敗時に作業員情報の登録を引き続き実行するかを促すダイアログ */}
        <Confirmation
          rootClassName={Style.ccusConnectErrorDialog}
          visible={
            this.props.pageStatus.ID === WORKER_PAGE_STATUS.NEW.ID &&
            this.state.dialogStatus ===
              DIALOG_STATUS.ccusConnectErrorDialogEnabled.id
          }
          confirmButtonText={messageUtility.getMessage('I-002-005-13')}
          negativeButtonClassName='btn'
          cancelButtonText={messageUtility.getMessage('I-002-005-12')}
          title={data.dialog.ccusConnectErrorDialog.title}
          message={
            <CcusConnectErrorDialog
              errorMessage={this.state.ccusConnectErrorMessage}
              isCcusJigyousyaConnected={this.props.isCcusJigyousyaConnected}
              isAgencyRegister={this.props.isAgencyRegister}
            />
          }
          isNegative
          onConfirm={() => this.registerWorkerInfo()}
          onCancel={this.closeDialog}
        />

        {/* CCUS連携失敗時に作業員情報の更新を引き続き実行するかを促すダイアログ */}
        <Confirmation
          rootClassName={Style.ccusConnectErrorDialog}
          visible={
            this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID &&
            this.state.dialogStatus ===
              DIALOG_STATUS.ccusConnectErrorDialogEnabled.id
          }
          confirmButtonText={messageUtility.getMessage('I-002-005-14')}
          negativeButtonClassName='btn'
          cancelButtonText={messageUtility.getMessage('I-002-005-12')}
          title={data.dialog.ccusConnectErrorDialog.title}
          message={
            <CcusConnectErrorDialog
              errorMessage={this.state.ccusConnectErrorMessage}
              isCcusJigyousyaConnected={this.props.isCcusJigyousyaConnected}
              isAgencyRegister={this.props.isAgencyRegister}
            />
          }
          isNegative
          onConfirm={() => this.updateWorkerInfo()}
          onCancel={this.closeDialog}
        />

        <Confirmation
          rootClassName='ccusConnectErrorDATN0203EDialog'
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.ccusConnectErrorDATN0204EDialogEnabled.id
          }
          confirmButtonText={messageUtility.getMessage('I-002-005-13')}
          negativeButtonClassName='btn'
          cancelButtonText={messageUtility.getMessage('I-002-005-12')}
          title={data.dialog.ccusConnectErrorDialog.title}
          message={
            <CcusConnectErrorDialog
              isErrorDATN0204E={true}
              selectCompanyName={this.props.selectCompanyName}
              ccusEngineerId={ccus_engineer_id}
              ccusJigyousyaId={this.props.ccusJigyousyaId}
            />
          }
          onConfirm={() => {
            if (isEditPage) {
              this.updateWorkerInfo();
            } else {
              this.registerWorkerInfo();
            }
          }}
          onCancel={this.closeDialog}
        />

        {/* 新規作成・編集をやめる時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => this.backToPage()}
          onCancel={this.closeDialog}
        />

        {/* 作業員一覧へ戻る時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => this.moveToWorkerList()}
          onCancel={this.closeDialog}
        />

        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.ccusNotMatchingRankNameCode.id
          }
          title={messageUtility.getMessage('I-000-219')}
          multilineText={true}
          message={messageUtility.getMessage('I-000-220')}
          effectiveButtonClassName='btn'
          cancelButtonText={messageUtility.getMessage('I-002-005-12')}
          confirmButtonText={messageUtility.getMessage(
            isEditPage ? 'I-002-005-14' : 'I-002-005-13'
          )}
          onConfirm={() => {
            this.closeDialogNotMatchingRankNameCode();
            if (isEditPage) {
              this.updateWorkerInfo(true);
            } else {
              this.registerWorkerInfo(true);
            }
          }}
          onCancel={() => this.closeDialogNotMatchingRankNameCode(true)}
        />

        {/* CCUS通信中のダイアログ */}
        <CommonModal
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.ccusConnectingDialogEnabled.id
          }
        >
          <CcusConnectingDialog />
        </CommonModal>

        {/* 作業員登録完了ダイアログ */}
        <Information
          visible={
            this.state.dialogStatus === DIALOG_STATUS.registerDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-196')}
          message={messageUtility.getMessage('I-000-197')}
          buttonText={messageUtility.getMessage('I-000-017')}
          multilineText={true}
          onClose={this.closeRegisterAndUpdateDialog}
        />

        {/* 作業員更新完了ダイアログ */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.updateSuccessDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-198')}
          message={messageUtility.getMessage('I-000-199')}
          buttonText={messageUtility.getMessage('I-000-017')}
          multilineText={true}
          onClose={this.closeRegisterAndUpdateDialog}
        />

        {/* 作業員登録・更新時のCCUS連携成功した場合に表示するダイアログ */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.ccusConnectSuccessDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-200')}
          message={messageUtility.getMessage('I-000-201')}
          buttonText={messageUtility.getMessage('I-000-017')}
          multilineText={true}
          onClose={this.closeRegisterAndUpdateDialog}
        />
      </React.Fragment>
    );
  }
}

/**
 * 初回CCUS連携ダイアログ
 * @props {boolean} approvedFlag: 同意するボタンにチェックしたか？
 * @props {function} onChange: チェックボックスにチェックした時の処理
 * */
const WorkersCcusConnectConfirmDialog = ({ approvedFlag, onChange }) => {
  // 画面表示
  return (
    <div>
      <p className='description'>{messageUtility.getMessage('I-002-005-05')}</p>
      <div className='approved-check-box'>
        <label>
          <input
            type='checkbox'
            checked={approvedFlag}
            onChange={event => onChange(event)}
          />
          <span>{messageUtility.getMessage('I-000-055')}</span>
        </label>
      </div>
    </div>
  );
};

/**
 * CCUS連携失敗時に作業員情報の登録・更新を引き続き実行するかを促すダイアログ
 * @props {string} errorMessage: エラーメッセージ
 * @props {boolean} isErrorDATN0204E
 * @props {string} selectCompanyName
 * @props {string} ccusJigyousyaId
 * @props {string} ccusEngineerId
 * @props {Boolean} isCcusJigyousyaConnected
 * @props {Boolean} isAgencyRegister:代理ログインか？
 * */
const CcusConnectErrorDialog = ({
  errorMessage = '',
  isErrorDATN0204E = false,
  selectCompanyName = '',
  ccusJigyousyaId = '',
  ccusEngineerId = '',
  isCcusJigyousyaConnected,
  isAgencyRegister,
}) => {
  // 画面表示

  if (isErrorDATN0204E) {
    return (
      <div>
        <Box sx={{
          wordBreak: 'break-all',
          overflowWrap: 'anywhere',
        }}>
          {`この技能者ID：${ccusEngineerId}は、CCUS上で${selectCompanyName}（事業者ID：${ccusJigyousyaId}）に関連付けされていないため連携に失敗しました。`}
        </Box>
        <span>
          Buildeeで作業員をCCUS連携するためには事前にCCUSで技能者と所属事業者の関連付けが必要です。
        </span>
        <Box my='8px'>
          <img
            src={ConnectCCUSErrorImage}
            alt='icon-ccus'
          />
        </Box>
        <span>
          CCUSでの関連付けの概要と確認方法については
          <a
            href={FAQ_URL.CCUS_ASSOCIATION}
            target='_blank'
            rel='noreferrer noopener'
            className='clickable-text'
          >
            こちら
          </a>
          をご確認ください。
        </span>
        <br />
        <span>
          CCUSでの関連付けの手順については
          <a
            href={FAQ_URL.CCUS_DETAIL}
            target='_blank'
            rel='noreferrer noopener'
            className='clickable-text'
          >
            こちら
          </a>
          をご確認ください。
        </span>
      </div>
    );
  }
  if (
    !isCcusJigyousyaConnected ||
    isCcusJigyousyaNotConnectedError(errorMessage)
  ) {
    const prefix = isAgencyRegister ? (
      <span className='bold'>代行先の</span>
    ) : (
      ''
    );
    const href = isAgencyRegister
      ? ZENDESK_URL_GUIDE.AGENCY_CCUS_CONNECT_WARNING
      : ZENDESK_URL_GUIDE.CCUS_CONNECT_WARNING;
    return (
      <div>
        <p>CCUS連携に失敗しました。</p>
        <br />
        <p>{prefix}CCUS連携に必要な初期設定が完了していません。</p>
        <p>
          {prefix}会社情報のCCUS連携情報を入力し、再度CCUS連携を行ってください。
        </p>
        <br />
        <p>
          {prefix}CCUS連携の初期設定の詳細は
          <a
            className='clickable-text'
            href={href}
            target='_blank'
            rel='noreferrer noopener'
          >
            こちら
          </a>
          をご確認ください。
        </p>
        <br />
        <p>{messageUtility.getMessage('I-002-005-10')}</p>
      </div>
    );
  }
  return (
    <div>
      <p className='description'>
        {replaceTagInErrorMessage(errorMessage)}
        <div>
          CCUS連携エラーの詳細は
          <a
            className='clickable-text'
            href={ZENDESK_URL_GUIDE.CCUS_WORKER_CONNECT}
            target='_blank'
            rel='noreferrer noopener'
          >
            こちら
          </a>
          をご確認ください。
        </div>
      </p>
      <p className='description'>{messageUtility.getMessage('I-002-005-09')}</p>
      <p className='description'>{messageUtility.getMessage('I-002-005-10')}</p>
    </div>
  );
};

// 定数
const data = {
  buttonLink: {
    label: '作業員一覧',
    defaultClassName: 'btn-text--sm',
  },
  defaultButton: {
    label: '',
    className: 'btn',
  },
  header: {
    new: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        register: {
          label: '登録',
          className: 'btn--effective',
        },
      },
    },
    confirm: {
      button: {
        edit: {
          label: '編集',
          className: 'btn',
        },
        updateCcusInfo: {
          label: 'CCUS情報を最新化',
          className: 'btn--effective',
        },
      },
    },
    edit: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        update: {
          label: '更新',
          className: 'btn--effective',
        },
      },
    },
  },
  dialog: {
    WorkersCcusConnectConfirm: {
      title: 'CCUS連携確認',
    },
    ccusConnectErrorDialog: {
      title: '連携に失敗しました',
    },
  },
};

const LevelWorkerForm = ({
  pageStatus,
  event,
  rankConsistencyStatus,
  rankNameCodeCCUS,
  rankNameCode = null,
  dialogStatus,
  rankConsistencyCheckedAt = null,
  ccusSyncedStatus = null,
  isCcusConnectSuccess = false,
  isCcusJigyousyaDeleted,
}) => {
  const isShowTranScriptCcus = isCcusConnectSuccess && rankNameCodeCCUS;

  const renderRankConsistencyStatusMsg = () => {
    if (pageStatus === WORKER_PAGE_STATUS.CONFIRM) {
      return;
    }
    let message = getMessageRankConsistencyStatus(rankConsistencyStatus);
    const isUnConfirmConsitencyStatus =
      rankConsistencyStatus === RANK_CONSISTENCY_STATUS.UN_CONFIRM.value;

    switch (pageStatus) {
      case WORKER_PAGE_STATUS.NEW:
        if (isUnConfirmConsitencyStatus) {
          message = '';
        }
        break;
      case WORKER_PAGE_STATUS.EDIT:
        if (
          ccusSyncedStatus === CCUS_SYNCED_STATUS.DONE.ID &&
          isUnConfirmConsitencyStatus
        ) {
          message = '';
        }
        break;
    }
    return (
      <React.Fragment>
        {!!message && (
          <FormElementContainerItem>{message}</FormElementContainerItem>
        )}
        <FormElementContainerItem>
          {messageUtility.getMessage('I-000-218')}
        </FormElementContainerItem>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {/* BLDE_V2-50226 CCUS事業者IDは削除された場合に、転記情報は表示されない */}
      <FormListSubHeader
        title='技能レベル'
        ccusComponent={
          isShowTranScriptCcus && !isCcusJigyousyaDeleted && <CcusTitleBlock />
        }
      />
      {/* BLDE_V2-50226 CCUS事業者IDは削除された場合に、転記情報は表示されない */}
      <FormListItem label='技能レベル'>
        <FormElement
          ccusComponent={
            isShowTranScriptCcus &&
            !isCcusJigyousyaDeleted && (
              <CcusLineComponent
                onClick={() =>
                  event.transcriptCcusWorkerValue(rankNameCodeCCUS)
                }
              >
                {getLevelWorkerName(rankNameCodeCCUS)}
              </CcusLineComponent>
            )
          }
        >
          {pageStatus === WORKER_PAGE_STATUS.CONFIRM ? (
            rankNameCode ? (
              <div>{getLevelWorkerName(rankNameCode)}</div>
            ) : (
              <div />
            )
          ) : (
            <React.Fragment>
              <select
                name='rank_name_code'
                tabIndex={
                  dialogStatus === DIALOG_STATUS.disabled.id
                    ? TAB_KEY_STATUS.enabled
                    : TAB_KEY_STATUS.disabled
                }
                onChange={e => event.setValue(e)}
              >
                <option value=''>技能レベルを選択</option>
                {_.map(LEVEL_WORKER, level => (
                  <option
                    key={level.rank_name_code}
                    value={level.rank_name_code}
                    selected={level.rank_name_code === rankNameCode}
                  >
                    {level.rank_name}（{level.rank_color}）
                  </option>
                ))}
              </select>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
            </React.Fragment>
          )}
        </FormElement>
      </FormListItem>
      {!!rankNameCode && (
        <FormListItem label='CCUSとの整合性確認'>
          <FormElement>
            <FormElementContainer>
              <FormElementContainerItem>
                <FormElementContainerItemLabel>
                  <span
                    className={getColorRankConsistencyStatusName(
                      rankConsistencyStatus
                    )}
                  >
                    {getRankConsistencyStatusName(rankConsistencyStatus)}
                  </span>
                </FormElementContainerItemLabel>
                {rankConsistencyCheckedAt && (
                  <FormElementContainerItemLabel isSpace={true}>
                    {rankConsistencyStatus ===
                    RANK_CONSISTENCY_STATUS.NOT_MATCHING.value
                      ? '整合性確認日時'
                      : '確認日時'}
                    ：{rankConsistencyCheckedAt}
                  </FormElementContainerItemLabel>
                )}
              </FormElementContainerItem>
              {renderRankConsistencyStatusMsg()}
            </FormElementContainer>
          </FormElement>
        </FormListItem>
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/worker/page/WorkerInfo.jsx